export default __webpack_public_path__ + "static/img/xiaomi-logo-min.1ef07cf.png";